import axios from "axios"

const actionGetReportsSchema = async ({commit}) => {
  const reports_schema = await axios.get(`${process.env.VUE_APP_URL_API}/v1/reports/schema`);
  commit("SET_REPORT_LIST", reports_schema.data);
}

export default {
  actionGetReportsSchema
}